import React from "react";
import styles from "./loading.module.scss";
import clsx from "clsx";

const PageLoading = () => {
  return (
    <div
      data-testid="page-loading-container"
      className={styles["common-loading"]}
    >
      <div
        data-testid="spinner"
        className={clsx("spinner-border", "spinner")}
      />
    </div>
  );
};

export default PageLoading;
